import React from 'react';
import PropTypes from 'prop-types';

import List from './Views/List/Index';

export default function Index({ enterpriseId }) {
  return (
    <List enterpriseId={enterpriseId} />
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number,
};

Index.defaultProps = {
  enterpriseId: null,
};
